import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import { LoaderCircle } from 'lucide-react';

import { useLoader } from '../hooks';

export const Loader = () => {
    const { isLoading } = useLoader();

    useEffect(() => {
        if (isLoading) {
            document.body.classList.add('overflow-hidden');
        } else {
            document.body.classList.remove('overflow-hidden');
        }

        return () => {
            document.body.classList.remove('overflow-hidden');
        };
    }, [isLoading]);

    if (!isLoading) {
        return null;
    }

    return createPortal(
        <div className="w-screen h-screen flex flex-col items-center justify-center fixed inset-0 z-[1000] backdrop-blur-sm">
            <LoaderCircle className="w-[42px] h-[42px] animate-spin" />
        </div>,
        document.body
    );
};
